import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Context } from "../store/appContext";
import getApiBaseUrl from "../utils/api";
import "../styles/forms.css";

const API_URL = getApiBaseUrl();

const PasswordForm = () => {
  const { store, actions } = useContext(Context);
  const navigate = useNavigate();

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [formData, setFormData] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !formData.current_password ||
      !formData.new_password ||
      !formData.confirm_password
    ) {
      actions.showToast("Todos los campos son obligatorios", "error");
      return;
    }

    if (formData.new_password !== formData.confirm_password) {
      actions.showToast("Las contraseñas no coinciden", "error");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/users/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + store.token,
        },
        body: JSON.stringify({
          current_password: formData.current_password,
          new_password: formData.new_password,
        }),
      });

      const data = await response.json().catch(() => ({}));

      if (response.ok) {
        actions.showToast("Contraseña actualizada correctamente", "success");
        localStorage.setItem("must_change_password", "false");
        actions.changePasswordFlagUpdated?.();

        setFormData({
          current_password: "",
          new_password: "",
          confirm_password: "",
        });

        navigate(store.role === "scanner" ? "/pending-part-exits" : "/panel", {
          replace: true,
        });
      } else {
        if (response.status === 401 || response.status === 403) {
          await actions.handleApiError(response);
          return;
        }

        actions.showToast(
          data?.msg || data?.error || "Error al actualizar la contraseña",
          "error",
        );
      }
    } catch (error) {
      console.error(error);
      actions.showToast("Error del servidor", "error");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="password-form">
      <div className="mb-3">
        <label className="form-label">Contraseña actual</label>

        <div className="input-group">
          <input
            type={showCurrent ? "text" : "password"}
            className="form-control"
            name="current_password"
            value={formData.current_password}
            onChange={handleChange}
          />

          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setShowCurrent(!showCurrent)}
          >
            <i className={`bi ${showCurrent ? "bi-eye-slash" : "bi-eye"}`}></i>
          </button>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Nueva contraseña</label>

        <div className="input-group">
          <input
            type={showNew ? "text" : "password"}
            className="form-control"
            name="new_password"
            value={formData.new_password}
            onChange={handleChange}
          />

          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setShowNew(!showNew)}
          >
            <i className={`bi ${showNew ? "bi-eye-slash" : "bi-eye"}`}></i>
          </button>
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Confirmar nueva contraseña</label>

        <div className="input-group">
          <input
            type={showConfirm ? "text" : "password"}
            className="form-control"
            name="confirm_password"
            value={formData.confirm_password}
            onChange={handleChange}
          />

          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={() => setShowConfirm(!showConfirm)}
          >
            <i className={`bi ${showConfirm ? "bi-eye-slash" : "bi-eye"}`}></i>
          </button>
        </div>
      </div>

      <button type="submit" className="btn btn-primary">
        Cambiar contraseña
      </button>
    </form>
  );
};

export default PasswordForm;
